import React, { memo } from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import DashboardChartCard from "./DashboardChartCard";

const CHART_MARGIN = { top: 8, right: 12, left: 0, bottom: 0 };
const COMPLETED_COLOR = "#5b9cf5";
const OVERDUE_COLOR = "#f4a4a4";
const TAT_COLOR = "#86efac";

const OverdueTrendChart = ({ rows = [] }) => (
  <DashboardChartCard
    title="Overdue Trend — Team"
    subtitle="Completed, overdue, and TAT count per person"
  >
    <ResponsiveContainer width="100%" height={220}>
      <BarChart data={rows} margin={CHART_MARGIN} barGap={4} barCategoryGap="18%">
        <CartesianGrid vertical={false} stroke="#f0f1f3" />
        <XAxis
          dataKey="person"
          tick={{ fill: "#9ca3af", fontSize: 11 }}
          axisLine={false}
          tickLine={false}
          dy={8}
          interval={0}
        />
        <YAxis
          domain={[0, 15]}
          ticks={[0, 5, 10, 15]}
          tick={{ fill: "#9ca3af", fontSize: 12 }}
          axisLine={false}
          tickLine={false}
          width={28}
        />
        <Tooltip
          cursor={{ fill: "rgba(243, 244, 246, 0.5)" }}
          contentStyle={{
            borderRadius: 8,
            border: "1px solid #e8eaed",
            fontSize: 12,
          }}
        />
        <Bar
          dataKey="completed"
          name="Completed"
          fill={COMPLETED_COLOR}
          radius={[4, 4, 0, 0]}
          maxBarSize={18}
          isAnimationActive={false}
        />
        <Bar
          dataKey="overdue"
          name="Overdue"
          fill={OVERDUE_COLOR}
          radius={[4, 4, 0, 0]}
          maxBarSize={18}
          isAnimationActive={false}
        />
        <Bar
          dataKey="tatCount"
          name="TAT count"
          fill={TAT_COLOR}
          radius={[4, 4, 0, 0]}
          maxBarSize={18}
          isAnimationActive={false}
        />
      </BarChart>
    </ResponsiveContainer>
  </DashboardChartCard>
);

export default memo(OverdueTrendChart);
